"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var flyoutToggle_1 = require("spry-react/Flyout/flyoutToggle");
var buttonKeyPressHandler_1 = require("spry-react/utils/buttonKeyPressHandler");
var FilterFlyoutButton = /** @class */ (function (_super) {
    __extends(FilterFlyoutButton, _super);
    function FilterFlyoutButton(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleClickHandler = function () {
            _this.setState(function (prevState) { return { isOpen: !prevState.isOpen }; });
        };
        _this.onClickOutsideFlyout = function () {
            _this.setState({ isOpen: false });
        };
        _this.clearFilterClicked = function (e) {
            e.stopPropagation();
            _this.props.clearClickHandler();
        };
        _this.state = {
            isOpen: false
        };
        return _this;
    }
    FilterFlyoutButton.prototype.render = function () {
        var containerClasses = ("filter-button " + (this.props.filtered ? 'filtered' : '')).trim();
        return (React.createElement(flyoutToggle_1.FlyoutButtonToggle, { id: this.props.id, flyout: this.state.isOpen ? getFilterFlyoutDescriptor(this.props.flyout) : null, toggleClickHandler: this.toggleClickHandler, onClickOutsideFlyout: this.onClickOutsideFlyout },
            React.createElement("div", { className: containerClasses },
                React.createElement("a", { className: 'filter-button-main' },
                    React.createElement("span", { className: 'filter-button-message' }, "Filters\u2026"),
                    React.createElement("span", { className: 'filter-button-message-filtered' }, "Filtered")),
                React.createElement("span", { className: 'field-clear', title: 'Clear', onClick: this.clearFilterClicked, onKeyPress: buttonKeyPressHandler_1.buttonKeyPressHandler(this.props.clearClickHandler), tabIndex: 0, role: "button" }))));
    };
    return FilterFlyoutButton;
}(React.Component));
exports.FilterFlyoutButton = FilterFlyoutButton;
function getFilterFlyoutDescriptor(flyout) {
    return flyoutToggle_1.isButtonToggledFlyoutDescriptor(flyout)
        ? __assign(__assign({}, flyout), { flyoutClassName: flyout.flyoutClassName !== undefined
                ? flyout.flyoutClassName
                : 'filter-flyout' }) : {
        contents: flyout,
        flyoutClassName: 'filter-flyout'
    };
}
